export class Classdefinition {
  name: string;
  fdef: {};

  constructor(name, fdef) {
    this.name = name;
    this.setFieldDefinitions(fdef);
  }

  setFieldDefinitions(fdef: {}) {
    this.fdef = fdef;
  }

  getFieldDefinitions() {
    return this.fdef;
  }

  getFieldDefinition(name: string, fdefOptions: any = null) {
    if (name in this.fdef) {
      if (this.fdef[name].fieldtype == "select" || this.fdef[name].fieldtype == "multiselect") {
        let prepOptions = {};
        let selectOptions = [{label: "", value: ""}];
        for (let i in this.fdef[name].options) {
          if (fdefOptions && fdefOptions['hideOptions']) {
            if (fdefOptions['hideOptions'].indexOf(this.fdef[name].options[i].value) >= 0) {
              continue;
            }
          }
          selectOptions.push({label: this.fdef[name].options[i].key, value: this.fdef[name].options[i].value});
          prepOptions[this.fdef[name].options[i].value] = this.fdef[name].options[i].key;
        }
        this.fdef[name].prepOptions = prepOptions;
        selectOptions = selectOptions.sort((a, b) => {
          if (a.label > b.label) {
            return 1;
          }
          if (a.label < b.label) {
            return -1;
          }
          return 0;
        });
        this.fdef[name].selectOptions = selectOptions;
      }
      if (this.fdef[name].fieldtype == "gender") {
        this.fdef[name].prepOptions = {
          "female": "Madame",
          "male": "Monsieur"
        };
      }
      this.fdef[name]["classname"] = this.name;
      return this.fdef[name];
    }
  }
}
